<div id="complete-profile-container" role="main" aria-label="Complete Profile" class="row">

	<div class="content-area mt-5 mb-5 col-12 col-lg-10 mx-auto">
		<div #templateOutlet></div>
	</div>
</div>
